import { createRouter, createWebHistory } from 'vue-router'
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import ComponentsDemo from '@/views/ComponentsDemo.vue'
import Editor from '@/views/Editor.vue'
import AdvancedEditor from '@/views/AdvancedEditor.vue'
import Debug from '@/views/Debug.vue'
import Login from '@/views/Login.vue'
import { authService } from '@/services/authService'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: () => {
        // Redirect based on authentication status
        return authService.isAuthenticated() ? '/editor' : '/login'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { 
        title: 'Configuration Management - Login',
        requiresAuth: false,
        isPublic: true
      }
    },
    {
      path: '/components',
      name: 'components',
      component: ComponentsDemo,
      meta: { 
        // title: 'Config Frontend - Components',
        requiresAuth: true
      }
    },
    {
      path: '/editor',
      name: 'editor',
      component: Editor,
      meta: { 
        title: 'Configuration Management',
        requiresAuth: true
      }
    },
    {
      path: '/advanced-editor',
      name: 'advanced-editor',
      component: AdvancedEditor,
      meta: { 
        // title: 'Config Frontend - Advanced Editor',
        requiresAuth: true
      }
    },
    {
      path: '/debug',
      name: 'debug',
      component: Debug,
      meta: { 
        // title: 'Config Frontend - Debug',
        requiresAuth: true
      }
    }
  ]
})

// Authentication guard
router.beforeEach(async (to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
  // Update document title
  if (to.meta?.title) {
    document.title = `${to.meta.title}`
  }

  // Allow public routes without auth check
  if (to.meta.isPublic) {
    next()
    return
  }

  const isAuthenticated = authService.isAuthenticated()
  const requiresAuth = to.meta.requiresAuth !== false

  if (requiresAuth && !isAuthenticated) {
    // Redirect to login if route requires authentication
    console.log('[Router] Not authenticated, redirecting to login')
    next({ name: 'login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
